import {jsonMember, jsonObject} from "typedjson";
import {PitFinancingItem} from "./pit-financing-item";
import {DxCoreUtils} from "../../dx-core/utiles/dx-core-utils";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {PitFinancingRedistributionBySource} from "./pit-financing-redistribution-by-source";

/** Финансирование по источникам */
@jsonObject
export class PitActivityFinancingAmountBySource extends DxGridRow {

  /** id */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Год финансирования */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  year: number;

  /** Коды бюджетной классификации */
  @jsonMember({constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false })
  financingItem: PitFinancingItem;

  @jsonMember({name: 'financingItemId', constructor: Number, emitDefaultValue: false, isRequired: false })
  get financingItemId() {
    return this._financingItemId ? this._financingItemId : (this.financingItem ? this.financingItem.id : null);
  }

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  limitAmount: number;

  /** Сумма остатка лимита */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  limitRestAmount: number;

  /** Сумма резерва */
  @jsonMember({constructor: Number, emitDefaultValue: false, preserveNull: false, isRequired: false })
  reserveAmount: number = 0;

  /** Сумма финансирования */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  financingSum: number;

  /** Сумма финансирования - ?? */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  value: number;

  donorRows: PitFinancingRedistributionBySource[] = [];



  get isNew(): boolean {
    return this.id !== this._id;
  }

  private _fakeId = DxCoreUtils.randomHexaDecimal();

  get id(): any {
    return this._id ? this._id : this._fakeId;
  }

  set id(value: any) {
    this._id = value;
  }

  getRowId() {
    return this.id;
  }

  private _financingItemId: number;

  set financingItemId(value: number) {
    this._financingItemId = value;
  }

  get budgetLevel(): string {
    return this.financingItem.budgetLevelId === 1 ? 'Региональный' : 'Федеральный';
  }

  get normType(): string {
    return this.financingItem.normTypeId === 1 ? 'Норматив' : 'Сверхнорматив';
  }

  get overrunSum(): number {
    return this.value - this.limitRestAmount;
  }

}
